import React from "react";
// import Feedback from "./Feedback";
import { useNavigate } from "react-router-dom";

const SessionExpiredPopup = ({
  onContinueSession,
  onEndSession,
  newSession,
  sessionExtend,
}) => {
  const navigate = useNavigate();
  // const [showFeedback, setShowFeedback] = useState(false);
  console.log(newSession);

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center font-sans">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl z-50">
        <div className="text-center">
          {sessionExtend ? (
            <h2 className="text-2xl font-semibold text-gray-800">
              Session Expired
            </h2>
          ) : (
            <h2 className="text-2xl font-semibold text-gray-800">
              Your Session Has Timed Out
            </h2>
          )}
          {sessionExtend ? (
            <>
              <p className="text-gray-600 font-sans text-xl mt-4 leading-loose">
                This session has expired,
              </p>
              <p>
                This session has expired. The session can only be extended
                once."
              </p>
            </>
          ) : (
            <p className="text-gray-600 font-sans text-xl mt-4 leading-loose">
              This session has expired, would you like to extend the current
              session?
            </p>
          )}
          <div className="mt-6 space-x-4">
            {sessionExtend ? (
              <></>
            ) : (
              <button
                onClick={onContinueSession}
                className="px-6 py-3 bg-[#54b0af] text-white text-xl font-medium rounded-full shadow-md hover:bg-[#469b9a] transition duration-200 focus:outline-none focus:ring-2 focus:ring-[#54b0af] focus:ring-offset-2"
              >
                Stay & Discover
              </button>
            )}

            <button
              onClick={navigate("/")}
              className="px-6 py-3 bg-gray-200 text-[#54B0AF] hover:text-gray-600 text-xl font-gotham font-medium rounded-full shadow-md hover:bg-gray-300 transition duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
            >
              Exit Anyway
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredPopup;
